import { useEffect, useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { ScrollTop } from './components/ScrollTop'
import { Content } from './components/Content'
import { PageDataProvider } from './core'
import { useDispatch, useSelector } from 'react-redux'
import PageLoading from '../../app/routing/PageLoading'

import { reset } from '../../app/Redux/store'
import PageLoadingSend from '../../app/routing/PageLoadingSend'
import { isLoading } from '../../app/Redux/FrontEnd/Loading/LoadingSlice'
import { HeaderWrapperOnboarding } from './components/header/HeaderWrapperOnboarding'

const OnboardingLayout = () => {
  const loading = useSelector(isLoading)
  const loadingSend = useSelector((state: any) => state?.loadingSend)

  const dispatch = useDispatch()

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (!event?.storageArea?.token || !event?.storageArea?.permission) {
        dispatch(reset())
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [dispatch])

  useEffect(() => {
    // Add custom class on mount
    document.body.classList.add('page-onboarding-bg');

    // Remove when leaving page
    return () => document.body.classList.remove('page-onboarding-bg');
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadingComponent = useMemo(() => <PageLoading />, [loading])
  const loadingSendComponent = useMemo(
    () => <PageLoadingSend typeSend={loadingSend} />,
    [loadingSend]
  )

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <HeaderWrapperOnboarding />

        <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
          <div className='bg-danger'></div>
          <div className='post d-flex flex-column-fluid' id='kt_post'>
            <Content>
              <Outlet />
              {loading && loadingComponent}
              {loadingSend.length > 0 && loadingSendComponent}
            </Content>
          </div>
        </div>
      </div>
      <ScrollTop />
    </PageDataProvider>
  )
}

export { OnboardingLayout }
